import './App.css';
import 'antd/dist/antd.min.css'
import Layouts from './Layouts';
import { UserProvider } from './Context/UserContext';
import { ProfileProvider } from './Context/ProfileContext';
import { WalletProvider } from './Context/WalletContext';
import { ThemeProvider } from './Context/ThemeContext';
import { OrderProvider } from './Context/OrderContext';

function App() {
  return (
    <UserProvider>
      <ProfileProvider>
        <WalletProvider>
          <OrderProvider>
            <ThemeProvider>
              <Layouts/>
            </ThemeProvider>
          </OrderProvider>
        </WalletProvider>
      </ProfileProvider>
    </UserProvider>
  );
}

export default App;
